export default "__VITE_ASSET__d6f6a1d8__"